var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgView(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 31,
    height: 30,
    rx: 2.5,
    stroke: "#4759FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 13.4074C16.2547 13.4112 16.0112 13.4502 15.7769 13.5231C15.8853 13.7137 15.943 13.9289 15.9445 14.1481C15.9445 14.3184 15.911 14.4869 15.8458 14.6442C15.7807 14.8015 15.6852 14.9444 15.5648 15.0648C15.4444 15.1851 15.3015 15.2806 15.1443 15.3458C14.987 15.4109 14.8184 15.4444 14.6482 15.4444C14.429 15.4429 14.2138 15.3852 14.0232 15.2768C13.8728 15.7983 13.8903 16.3539 14.0733 16.8649C14.2562 17.3758 14.5953 17.8163 15.0424 18.1239C15.4896 18.4314 16.0222 18.5905 16.5648 18.5785C17.1074 18.5666 17.6325 18.3842 18.0657 18.0572C18.4989 17.7303 18.8182 17.2753 18.9784 16.7568C19.1387 16.2383 19.1317 15.6825 18.9585 15.1681C18.7854 14.6538 18.4547 14.2069 18.0135 13.8909C17.5722 13.5749 17.0428 13.4058 16.5 13.4074ZM23.0862 15.662C21.8308 13.2127 19.3456 11.5555 16.5 11.5555C13.6544 11.5555 11.1685 13.2139 9.91392 15.6623C9.86096 15.767 9.83337 15.8827 9.83337 16.0001C9.83337 16.1175 9.86096 16.2332 9.91392 16.338C11.1692 18.7873 13.6544 20.4444 16.5 20.4444C19.3456 20.4444 21.8315 18.7861 23.0862 16.3377C23.1391 16.233 23.1667 16.1173 23.1667 15.9999C23.1667 15.8825 23.1391 15.7668 23.0862 15.662ZM16.5 19.3333C14.2165 19.3333 12.1229 18.0602 10.9924 16C12.1229 13.9398 14.2162 12.6667 16.5 12.6667C18.7838 12.6667 20.8771 13.9398 22.0077 16C20.8774 18.0602 18.7838 19.3333 16.5 19.3333Z",
    fill: "#4759FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/View.08db10cdbc1aef8f87dbf4717b3dd4fe.svg";
export { ForwardRef as ReactComponent };